<template>
  <el-form :model="query" ref="query" label-width="70px" class="search-form">
    <el-row>
      <el-form-item label="关键词" prop="keyword">
        <el-col>
          <el-input v-model="query.keyword" prefix-icon="Search"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="" label-width="20px">
        <el-button type="primary" icon="search" @click="fetchs">
          搜索
        </el-button>
      </el-form-item>
    </el-row>
  </el-form>

  <basic-table ref="table" class="table" :query="query" :selects="checkedKeys" @handler="fetchs">
    <template v-slot:category="scope">
      <span v-if="scope.row.category == 'global'">通用</span>
      <span v-else-if="scope.row.category == 'permission'">权限</span>
      <span v-else>未知</span>
    </template>
    <template v-slot:birthday="scope">
      <i class="el-icon-time" v-show="scope.row.birthday"></i>

      <span style="margin-left: 10px">{{ (scope.row.birthday || "").split(" ")[0] }}</span>
    </template>
  </basic-table>
</template>
<script>
import { fetchRoles } from "@/api/sys";
import BasicTable from "@/components/basic-table.vue";

export default {
  name: "UserRole",
  components: { BasicTable },
  props: {},
  data() {
    return {
      query: {
        keyword: "",
        columns: [
          { type: "selection" },
          { type: "index", label: "序号" },
          { type: "template", prop: "category", label: "类别", width: "120", sortable: true, searchable: true, },
          { prop: "name", label: "角色名", width: "150", sortable: true, searchable: true, },
          { prop: "code", label: "角色编号", sortable: true, searchable: true, width: "110", },
          { prop: "sortCode", label: "排序号", sortable: true, width: "100", },
          { prop: "remark", label: "备注", sortable: true, showOverflowTooltip: true },
          { prop: "createDate", label: "创建时间", width: "150" },
        ],
        selects: [],
      },
      checkedKeys: [],
    };
  },
  methods: {
    fetchs() {
      let { data, records, total, ...params } = { ...this.query };
      this.$kaung.search(params).then((res) => {
        this.query = { ...res.data };//selects: this.checkedKeys,
      });
    },
    
    getSelectIds() {
      console.log('getSelectIds', this.$refs.table.selectIds);
      return this.$refs.table.selectIds;
    },
    setCheckedKeys(keys) {
      this.checkedKeys = keys;
      console.log('setCheckedKeys', keys);
    },
  },
  mounted() {
    //kaung插件初始化
    this.$kaung.init("BaseRole");

    this.fetchs();
  },
};
</script>